import NiceSelect from 'nice-select2'

import {
  cleanCartData, addItemToCart, checkIfItemAlreadyInCart,
} from './utils/cart'
import { showNotification } from './utils/notification'
import { showPopup } from './utils/popup'


addEventListener("load", (event) => {

})

const galleryCarouselElement = document.getElementById('gallery-carousel')
const galleryCarouselElementArrowUp = document.getElementById('gallery-carousel-arrow-up')
const galleryCarouselElementArrowDown = document.getElementById('gallery-carousel-arrow-down')

window.document.addEventListener('DOMContentLoaded', () => {
  var itemNiceSelect = null

  if (itemNiceSelect == null) {
    itemNiceSelect = new NiceSelect(document.getElementById('sizes-select'), {
      searchable: false
    })
  }

  // DEV
  // cleanCartData()

  showIfNeedCssCarouselArrows()

  galleryCarouselElement.addEventListener('scroll', function() {    
    let maxSrollHeight = galleryCarouselElement.scrollHeight - galleryCarouselElement.clientHeight

    var scrollTop = (galleryCarouselElement.scrollTop) - (galleryCarouselElement.clientTop || 0)

    if (scrollTop == 0) {
      galleryCarouselElementArrowUp.style.visibility = 'hidden'
    } else {
      galleryCarouselElementArrowUp.style.visibility = 'visible'
    } 
    
    if (scrollTop < maxSrollHeight) {
      galleryCarouselElementArrowDown.style.visibility = 'visible'
    } else {
      galleryCarouselElementArrowDown.style.visibility = 'hidden'
    }
  })

  const itemDescriptionElement = document.getElementById('addi-description-c__span')

  if (itemDescriptionElement.scrollHeight > itemDescriptionElement.offsetHeight) {
    document.getElementById('additional-info__c__more').style.display = 'block'
  }

}, { once: true })

window.document.openNewReviewPopup = (e) => {
  showPopup('new-review', {
    itemPK: e.currentTarget.dataset.itemPk,
    itemName: e.currentTarget.dataset.itemName,
  })
}

window.document.additionalMenuClick = (e, type) => {

  // Buttons

  const addiDescriptionButton = document.getElementById('addi-menu-description')
  const addiCareButton = document.getElementById('addi-menu-care')

  addiDescriptionButton.classList.remove('additional-info__menu__option--active')
  addiCareButton.classList.remove('additional-info__menu__option--active')

  if (type == 'description') {
    addiDescriptionButton.classList.add('additional-info__menu__option--active')
  } else if (type == 'care') {
    addiCareButton.classList.add('additional-info__menu__option--active')
  }

  // Containers

  const addiDescriptionContainer = document.getElementById('addi-description-c')
  const addiCareContainer = document.getElementById('addi-care-c')
  
  addiDescriptionContainer.style.display = 'none'
  addiCareContainer.style.display = 'none'

  if (type == 'description') {
    addiDescriptionContainer.style.display = 'block'
  } else if (type == 'care') {
    addiCareContainer.style.display = 'block'
  }

}

//

window.document.selectCCType = (e, current_cc, new_cc, url) => {
  if (current_cc != new_cc) 
    window.location = url
  
  /*
  const allMiniCards = document.querySelectorAll('.cc-mini-card')

  allMiniCards.forEach((el) => el.classList.remove('cc-mini-card--active'))

  e.currentTarget.classList.add('cc-mini-card--active')
  */
  
}

//

window.document.galleryCarouselSlideUp = () => {
  galleryCarouselElement.scroll({ top: galleryCarouselElement.scrollTop - 100, behavior: 'smooth' })
}

window.document.galleryCarouselSlideDown = () => {
  galleryCarouselElement.scroll({ top: galleryCarouselElement.scrollTop + 100, behavior: 'smooth' })
}

//

const ccsCarouselElement = document.getElementById('ccs-carousel')
const ccsCarouselElementArrowLeft = document.getElementById('ccs-carousel-arrow-left')
const ccsCarouselElementArrowRight = document.getElementById('ccs-carousel-arrow-right')

const showIfNeedCssCarouselArrows = () => {
  const count = ccsCarouselElement.dataset.count

  if (count > 3) {
    ccsCarouselElementArrowLeft.style.display = 'block'
    ccsCarouselElementArrowLeft.style.opacity = '0.3';
    ccsCarouselElementArrowRight.style.display = 'block'
  }

  // scroll to selected CC

  ccsCarouselElement.childNodes.forEach((el) => {
    if (el.classList && el.classList.contains('cc-mini-card--active')) {
      ccsCarouselElement.scrollTo(el.offsetLeft, 0)
    }
  })

  toggleCssCarouselArrows()
}

const toggleCssCarouselArrows = () => {
  var maxScrollLeft = ccsCarouselElement.childElementCount * 114 - ccsCarouselElement.clientWidth

  if (ccsCarouselElement.scrollLeft == 0) {
    ccsCarouselElementArrowLeft.style.opacity = '0.3';
    ccsCarouselElementArrowRight.style.opacity = '0.8';

  } else if (ccsCarouselElement.scrollLeft >= maxScrollLeft - 20) {
    ccsCarouselElementArrowLeft.style.opacity = '0.8';
    ccsCarouselElementArrowRight.style.opacity = '0.3';
 
  } else {
    ccsCarouselElementArrowLeft.style.opacity = '0.8';
    ccsCarouselElementArrowRight.style.opacity = '0.8';

  }
}

window.document.ccsCarouselSlideLeft = () => {
  ccsCarouselElement.scroll({ left: ccsCarouselElement.scrollLeft - 127, behavior: 'smooth' })
  toggleCssCarouselArrows()
}

window.document.ccsCarouselSlideRight = () => {
  ccsCarouselElement.scroll({ left: ccsCarouselElement.scrollLeft + 127, behavior: 'smooth' })
  toggleCssCarouselArrows()
}

// 

window.document.selectGalleryMiniCard = (e) => {
  // 1. get img src
  // 2. replace '_min' with ''
  // 3. update big image

  let src = e.currentTarget.querySelector('img').src
  src.replace('_min', '')

  document.getElementById('gallery-img').querySelector('img').src = src

  // 

  const galleryMiniCards = document.querySelectorAll('.gallery-mini-card')
  galleryMiniCards.forEach((el) => el.classList.remove('gallery-mini-card--active'))

  e.currentTarget.classList.add('gallery-mini-card--active')

}

//

const switchCartButtonIfNeed = (itemPK, itemCC, selectedSize) => {
  const addToCartButton = document.getElementById('add-to-cart-button')
  const goToCartButton = document.getElementById('go-to-cart-button')

  let alreadyExist = checkIfItemAlreadyInCart({
    pk: itemPK,
    cc: itemCC,
    size: selectedSize,
  })

  if (alreadyExist) {
    addToCartButton.style.display = 'none'
    goToCartButton.style.display = 'block'
  } else {
    addToCartButton.style.display = 'block'
    goToCartButton.style.display = 'none'
  }
}

window.document.sizesSelectChanged = (e) => {

  const addToCartButton = document.getElementById('add-to-cart-button')
  const goToCartButton = document.getElementById('go-to-cart-button')

  const itemPK = addToCartButton.dataset.itemPk
  const itemCC = addToCartButton.dataset.itemCc

  switchCartButtonIfNeed(itemPK, itemCC, e.currentTarget.value)

}

window.document.addToCart = (e) => {

  const itemPK = e.currentTarget.dataset.itemPk
  const itemCC = e.currentTarget.dataset.itemCc

  const selectedSizeContainer = document.getElementById('size-picker-c')
  const selectedSizeElement = document.getElementById('sizes-select')
  const selectedSize = selectedSizeElement.value

  if (selectedSize == 'null') {
    showNotification({ text: 'Пожалуйста выберите размер', type: 'info' })
    selectedSizeContainer.classList.add('shake-horizontal--active')
    setTimeout(() => {
      selectedSizeContainer.classList.remove('shake-horizontal--active')
    }, 300)
    return;
  }

  addItemToCart({
    pk: itemPK,
    cc: itemCC,
    size: selectedSize,
    count: 1,
  })

  switchCartButtonIfNeed(itemPK, itemCC, selectedSize)

}

window.document.goToCart = (e) => {
  window.open('/checkout/', '_blank').focus()
}


window.document.itemBuyInOneButtonClick = (e) => {
  let sizes_str = e.currentTarget.dataset.sizes
  sizes_str = sizes_str.replaceAll('\'', '"')
  let sizes = JSON.parse(sizes_str)

  showPopup('buy-in-one', {
    itemName: e.currentTarget.dataset.name,
    itemImgUrl: e.currentTarget.dataset.imgurl,
    itemVendorCode: e.currentTarget.dataset.vendorCode,
    itemPK: e.currentTarget.dataset.itempk,
    itemCC: e.currentTarget.dataset.itemcc,
    sizes: sizes,
  })
}

window.document.showMoreDescription = (e) => {

  document.getElementById('addi-description-c__span').classList.remove('line-climp-10')

  e.currentTarget.style.display = 'none'

}



